exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white;\n  padding: 0;\n  color: #848484;\n}\n\nh2 {\n  font-size: 1.2rem;\n  padding: 0.25rem 0;\n}\n\nh3 {\n  font-size: 1rem;\n  padding: 0.25rem 0;\n}\n\n.DatoCMS-button svg {\n  fill: #ed6b5e;\n  margin-right: .5em;\n}\n\nul li ul li ul li {\n  padding: 5px;\n  cursor: move;\n  border: solid 1px white;\n  background-color: white;\n}\n\nul li ul li ul li:hover {\n  border: solid 1px #ddd;\n}\n\nul li ul li span{\n  margin-right: 25px;\n}", ""]);

// exports
